import s from "styled-components";
import MasterBadges from "_c/Master/Badges";

export const Wrap = s.li`
  color: white;
  position: relative;
  margin-bottom: 20px;
  padding: 15px;
  padding-bottom: 22px;
  background: var(--grad-primary-n);
  border-radius: 9px;
  ${({ isPremium, theme }) =>
    isPremium ? `border: 3px solid ${theme.color.golden}` : ""};
  box-shadow: ${({ isPremium, theme }) =>
    isPremium ? theme.shadow.golden : "0px 6px 20px var(--color-primary)"};
  :last-child {
    margin-bottom: 0;
  }
`;
export const InnerWrap = s.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media(max-width: 767px) {
    flex-direction: column;
  }
`;
export const TopSect = s.div`
  display: flex;
`;
export const StartPrice = s.span`
  margin-inline-start: auto;
  margin-inline-end: 40px;
  position: relative;
  top: 4px;
  align-self: flex-start;
  color: var(--color-primary);
  font-size: 18px;
  font-weight: 600;
  @media(max-width: 767px) {
    position: absolute; 
    bottom: 10px;
    right: 10px;
    top: auto;
    margin-inline-end: 0;
    align-self: inherit;
  }

`;
export const ContentContainer = s.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 85px;
  @media(max-width: 991px) {
    padding-left: 0;
  }
`;
export const Name = s.span`
  padding-top: 5px;
  font-size: 18px;
  font-weight: 500;
`;
export const NameAndBadges = s.div`
  display: flex;
  align-items: center;
  margin-inline-start: 20px;
  @media(max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const ReviewsContainer = s.div`
  display: flex;
  align-items: flex-end;
  img {
    width: 45px;
    margin-inline-end: 5px;
  }
`;
export const Rate = s.span`
  margin-inline-end: 10px;
  font-size: 36px;
  font-weight: 600;
  background: linear-gradient(-30deg, #c89812 0%, #f8c40c 30%, #c89812 83%, #ffe68f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;
export const ReviewsCount = s.span`
  padding-bottom: 7px;
`;
export const AddressContainer = s.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  svg {
    min-width: 15px;
    opacity: .7;
  }
  address {
    max-width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-inline-start: 8px;
    font-style: normal;
    color: white;
    font-weight: 400;
    padding-bottom: 1px;
  }
  @media(max-width: 767px) {
    margin-top: 15px;
  }
`;
export const Badges = s(MasterBadges)`
  margin-inline-start: 10px;
  margin-top: 5px;
  @media(max-width: 767px) {
    margin-top: 10px;
    margin-inline-start: 0;
  }
`;
export const Actions = s.div`
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
`;
export const ActionButton = s.button`
  display: flex;
  align-items: center;
  outline: none;
  color: white;
  text-decoration: none;
  margin-bottom: 10px;
  span {
    font-weight: 700;
    border-bottom: 2px solid white;
    padding-bottom: 2px;
    transition: border-color .25s ease;
  }
  margin-inline-end: 20px;
  :focus, :hover {
    span {
      border-color: transparent;
    }
  }
`;
export const ActionIcon = s.div`
  margin-inline-end: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  height: 33px;
  min-width: 33px;
  min-height: 33px;
  background-color: var(--color-cta);
`;
